import { Modal } from 'antd';
import type { FC } from 'react';

import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import { useEmojis } from 'app/hooks/data/useEmojis';
import type { Picture } from 'app/typings';

import './EmojiModal.scss';

export const EmojiModal: FC<Props> = ({ visible, onSelect, onCancel }) => {
  const { data: emojis } = useEmojis();

  if (!emojis) {
    return null;
  }

  return (
    <Modal
      width={800}
      onCancel={onCancel}
      open={visible}
      title="Choose emoji"
      centered
      footer={[]}
      className="emoji-modal"
    >
      <div className="emoji-modal__container">
        {emojis.map((emoji) => (
          <div
            onClick={() => onSelect(emoji)}
            key={emoji.pictureId}
            className="emoji-modal__thumbnail"
          >
            <PictureComponent {...emoji} width={40} />
          </div>
        ))}
      </div>
    </Modal>
  );
};

type Props = {
  visible: boolean;
  onSelect: (emoji: Picture) => void;
  onCancel: () => void;
};
